import { dcCrossConnectTypeOptions } from "@/common/const";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const crossConnectManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "select",
    label: "Type",
    name: "DcServiceType",
    required: true,
    options: dcCrossConnectTypeOptions,
    defaultValue: dcCrossConnectTypeOptions[0].value,
  },
  {
    inputType: "text",
    label: "Quantity",
    name: "quantity",
    required: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    defaultValue: contractTermsOptions[0].value,
  },
];

export default crossConnectManualFormStrategy;
